module.exports = __webpack_public_path__ + "media/images/icons/outlined/behance-square-3afb0b11f108b2e4ae2558b54b34a8c0.svg";